// Testimonials inside the Telegram Mini App. TelegramShell handles the
// initData → JWT auth (stored in localStorage), so the shared Testimonials
// feed — including like + submit — works authenticated with no extra wiring.

import React from 'react';
import TelegramShell from '../components/TelegramShell';
import Testimonials from './Testimonials';

const TelegramTestimonials: React.FC = () => (
  <TelegramShell>
    <Testimonials embedded />
  </TelegramShell>
);

export default TelegramTestimonials;
